import { render, staticRenderFns } from "./payment_dp_split.vue?vue&type=template&id=001af51a"
import script from "./payment_dp_split.vue?vue&type=script&lang=js"
export * from "./payment_dp_split.vue?vue&type=script&lang=js"
import style0 from "./payment_dp_split.vue?vue&type=style&index=0&id=001af51a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports